<template>
  <div id="super-syndicate">
    <div style="max-width: 1600px; margin: 0 auto;">
      <SuperSyndicateHeader @changed="syndicationId = $event" />
      <main class="no-x-scroll">
        <SuperSyndicateStats :syndication-id="syndicationId" />
        <SuperSyndicateOverview :syndication-id="syndicationId" />
        <SuperSyndicateReports :syndication-id="syndicationId" />
      </main>
    </div>
  </div>
</template>

<script>
import SuperSyndicateHeader from './SuperSyndicateHeader'
import SuperSyndicateStats from './SuperSyndicateStats'
import SuperSyndicateOverview from './SuperSyndicateOverview'
import SuperSyndicateReports from './SuperSyndicateReports'

export default {
  components: {
    SuperSyndicateHeader,
    SuperSyndicateStats,
    SuperSyndicateOverview,
    SuperSyndicateReports,
  },

  data() {
    return {
      // Selected syndicate; changing it (from the header) refetches the
      // syndicate-specific sections without reloading the page.
      syndicationId: localStorage.getItem('syndication_id'),
    };
  },

  mounted() {

    // Array of stylesheets to load
    const stylesheets = [
      {
        id: 'fonts',
        href: 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons'
      },

    ];

    // Dynamically load each stylesheet
    stylesheets.forEach(sheet => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = sheet.href;
      link.id = sheet.id;
      document.head.appendChild(link);
    });

  },

  beforeUnmount() {

    // Remove all stylesheets when the component is destroyed
    const stylesheetIds = [
      'fonts',
    ];

    // Remove stylesheet
    stylesheetIds.forEach(id => {
      const link = document.getElementById(id);
      if (link) {
        link.remove();
      }
    });

  },
};
</script>

<style scoped src="./Styles/SuperSyndicate.css"></style>
